export const currentLocale =
  typeof window === 'object'
    ? navigator.languages[0] || window.Intl.DateTimeFormat().resolvedOptions().locale
    : 'en-US';
